export const props = {
  // Status
  progress: Boolean,

  // Options
  delay: {
    type: Number,
    default: 500
  }
}
